/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";

import { Tab } from "@headlessui/react";

import { scrollToBottomHeader } from "common/action-function/scrollToBottomHeader";

import Title from "components/atoms/Title";
import CardPackage from "components/molecules/CardPackage";
import TabListNew from "components/molecules/TabListNew/index";

/** ========== */

const PackagesNews = ({
  data,
  dataStatic,
  title,
  changePrice,
  tabBarClass,
  customCardColor,
  note,
  subFeeArr,
}) => {
  const dataEntitySuffix = data?.entitySuffix?.EntityTypes;

  const dataStaticPackage = dataStatic?.listPackage;
  const [defaultTab, setDefaultTab] = useState(0);

  const temp = dataEntitySuffix?.reduce((totalID, currentValue) => {
    totalID.push(`${currentValue.guid}-package`);

    return totalID;
  }, []);
  const dataStaticFilter = (id) => {
    const result = dataStaticPackage.find((fruit) => fruit.id == id);

    return result;
  };
  const dataLink = `${dataEntitySuffix[0]?.guid}-package`;

  useEffect(() => {
    if (dataLink.length > 0) {
      const url = window.location.href;

      setDefaultTab(
        temp.indexOf(url.split("#")[1]) < 0
          ? 0
          : temp.indexOf(url.split("#")[1])
      );
      if (url.search(`#${url.split("#")[1]}`) > 0) {
        const scrollToTable = document.getElementById("PriceTable");

        scrollToBottomHeader(scrollToTable);
      }
    }
  }, []);

  useEffect(() => {
    if (dataLink.length == 0) {
      setDefaultTab(0);
    }
  }, []);

  function caseInTotal(condition, store, value) {
    switch (condition) {
      case "add":
        return store + value;
      case "minus":
        return store - value;
      case "div":
        return store / value;
      case "multi":
        return store * value;
      default:
        return store;
    }
  }
  function calculateSubFee(data) {
    let totalFee = 0;
    const additionalServices = [...data.AdditionalServices];

    if (subFeeArr && subFeeArr.length > 0) {
      const clone_sub_fee_arr = [...subFeeArr];

      for (let index = 0; index < clone_sub_fee_arr.length; index++) {
        const element = clone_sub_fee_arr[index];

        if (element.entity_type_id === data.entity_type_id) {
          const elementConditionTotal = additionalServices.reduce(
            (store, current) => {
              if (current.id === element.id) {
                return caseInTotal(element.type, store, current.Fee.value);
              }

              return store;
            },
            totalFee
          );

          totalFee = elementConditionTotal;
        }
      }
    }

    return totalFee;
  }

  const checkLengthContent = dataEntitySuffix
    ?.map((item) => item.name)
    .join(" ").length;
  const countryId = data?.entitySuffix?.id;

  return (
    <div id="PriceTable" className="min-h-screen">
      <Title
        text={title}
        className={`bbc-title text-center ${
          dataStatic?.description && dataStatic?.description.length
            ? " mb-6"
            : " mb-6 lg:mb-10"
        }`}
      />
      {dataStatic?.description && dataStatic?.description.length > 0 && (
        <p className="m-auto mb-6 w-4/5 text-center lg:mb-10">
          {dataStatic?.description}
        </p>
      )}

      <div>
        <TabListNew
          activeTab={defaultTab}
          data={dataEntitySuffix?.map((item) => item.name)}
          tabLinks={dataEntitySuffix?.map((item) => `${item.guid}-package`)}
          tabListClass={
            data?.packages?.Packages?.every(
              (item) => item.entity_type_id === null
            )
              ? { display: "hidden" }
              : {
                  ...(checkLengthContent > 30 && {
                    display: "block md:flex justify-center",
                    border: "border-0 md:border border-bbc-neutral-600",
                    background: "bg-transparent md:bg-white",
                  }),
                  othersClass: `md:whitespace-nowrap ${tabBarClass}`,
                }
          }
          tabClass={{
            tabColor:
              " text-bbc-neutral-600 hover:text-bbc-brand-500 border-bbc-neutral-600 md:border-transparent mx-auto",
            tabColorActive: "text-bbc-brand-500 border-bbc-brand-500 bg-white",
            ...(checkLengthContent > 30 && {
              othersClass: "my-1 md:my-0  mx-auto",
            }),
          }}
        >
          <Tab.Panels className="mt-6 w-full ">
            {data?.entitySuffix?.EntityTypes?.map((entity, indexEntity) => {
              const dataPackages = data?.packages?.Packages?.every(
                (item) => item.entity_type_id === null
              )
                ? data?.packages?.Packages
                : data?.packages?.Packages.filter(
                    (item) => item.entity_type_id == entity.id
                  );
              const checkContentLengthMobile =
                dataPackages
                  ?.map((card) => card?.PackageType?.name.split(" ").join(""))
                  .join("").length > 30;

              return (
                <Tab.Panel
                  className={`focus:outline-none focus:outline-0 focus:ring-0 ${
                    dataStatic.listPackage?.find((el) => el?.kind == "standard")
                      ? "lg:mt-20"
                      : ""
                  }`}
                  as="div"
                  key={indexEntity}
                >
                  {/* Desktop */}
                  <div className="hidden lg:block">
                    <div className="row justify-center">
                      {dataPackages?.map((card, index) => {
                        const price = card?.Services.reduce(
                          (sum, item) => sum + item?.Fee?.value,
                          0
                        );
                        const discount = card?.Services.reduce((sum, item) => {
                          if (item.service_type_id === 49) {
                            return sum + item?.Fee?.value;
                          }

                          return sum;
                        }, 0);

                        const subFee = calculateSubFee(card);
                        const title = card?.PackageType?.name;
                        const itemStatic = dataStatic.listPackage[index];

                        return (
                          <div key={index} className="relative lg:col-4">
                            {itemStatic.best_seller && (
                              <div className="absolute -top-10 left-0 right-0 z-0 px-[15px]">
                                <div className=" mx-auto h-20 w-full rounded-t-[24px] bg-bbc-yellow-500  pt-1 text-center text-2xl font-semibold capitalize text-bbc-white">
                                  {itemStatic.seller_content || "Best Seller"}
                                </div>
                              </div>
                            )}
                            <CardPackage
                              {...itemStatic}
                              kind={title}
                              changePrice={changePrice}
                              price={price + subFee}
                              data={dataStaticFilter(card.id)}
                              {...(discount != 0 && {
                                sale_off: Math.abs(discount),
                              })}
                              dataSuffix={{
                                id: countryId,
                                name: data.entitySuffix?.sub_name,
                                suffixData:
                                  data?.entitySuffix?.EntityTypes[indexEntity],
                              }}
                              index={index}
                              customCardColor={customCardColor}
                              linkRegister={`/onboarding/register?country_id=${countryId}&entity_type_id=${entity?.id}&package_id=${card.id}`}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  {/* //moblie */}
                  <div className="block w-full lg:hidden">
                    <TabListNew
                      data={dataPackages
                        .map((card) => card?.PackageType?.name)
                        .filter((item) => item)}
                      tabListClass={
                        checkContentLengthMobile
                          ? {
                              display: "flex flex-col items-center",
                              border: "border-0",
                            }
                          : { background: "bg-white" }
                      }
                      tabClass={
                        checkContentLengthMobile
                          ? {
                              tabColorActive:
                                "bg-white border-bbc-brand-500 text-bbc-brand-500 my-0.5",
                              tabColor:
                                "bg-white border text-bbc-neutral-600 my-0.5",
                            }
                          : { padding: "py-3 px-4 sm:py-3 sm:px-6" }
                      }
                    >
                      <Tab.Panels className="mt-6 w-full">
                        {dataPackages?.map((card, index) => {
                          const price = card?.Services.reduce(
                            (sum, item) => sum + item?.Fee?.value,
                            0
                          );
                          const subFee = calculateSubFee(card);
                          const title = card?.PackageType?.name;
                          const itemStatic = dataStatic.listPackage[index];
                          const discount = card?.Services.reduce(
                            (sum, item) => {
                              if (item.service_type_id === 49) {
                                return sum + item?.Fee?.value;
                              }

                              return sum;
                            },
                            0
                          );

                          return (
                            <Tab.Panel
                              className={`${
                                itemStatic.best_seller ? "mt-16" : ""
                              } relative focus:outline-none focus:outline-0 focus:ring-0`}
                              as="div"
                              key={index}
                            >
                              {itemStatic.best_seller && (
                                <div
                                  style={{ maxWidth: "350px" }}
                                  className="absolute -top-10 left-0 right-0 z-0 mx-auto h-20 w-full rounded-t-[24px] bg-bbc-yellow-500  pt-1 text-center text-2xl font-semibold capitalize text-bbc-white"
                                >
                                  {itemStatic.seller_content || "Best Seller"}
                                </div>
                              )}
                              <CardPackage
                                {...itemStatic}
                                kind={title}
                                price={price + subFee}
                                data={dataStaticFilter(card.id)}
                                {...(discount != 0 && {
                                  sale_off: Math.abs(discount),
                                })}
                                {...(discount != 0 && {
                                  sale_off: Math.abs(discount),
                                })}
                                index={index}
                                customCardColor={customCardColor}
                                changePrice={changePrice}
                                dataSuffix={{
                                  id: countryId,
                                  name: data.entitySuffix?.sub_name,
                                  suffixData:
                                    data.entitySuffix?.EntityTypes[index],
                                }}
                                linkRegister={`/onboarding/register?country_id=${countryId}&entity_type_id=${entity?.id}&package_id=${card.id}`}
                              />
                            </Tab.Panel>
                          );
                        })}
                      </Tab.Panels>
                    </TabListNew>
                  </div>
                </Tab.Panel>
              );
            })}
          </Tab.Panels>
        </TabListNew>
      </div>

      {note && (
        <i
          className="mt-6 block rounded-2xl bg-[#F5F5F5] px-4 py-6 lg:mt-10 lg:px-10"
          dangerouslySetInnerHTML={{ __html: note }}
        />
      )}
    </div>
  );
};

export default PackagesNews;
